/** Smoothly scroll the window to the very top with a controllable (faster) duration. */
export function smoothScrollToTop(duration = 320): void {
  if (typeof window === 'undefined') return;

  const animate = () => {
    const start = window.scrollY;
    if (start <= 0) return;
    const startTime = performance.now();
    const easeOutCubic = (t: number) => 1 - Math.pow(1 - t, 3);

    const step = (now: number) => {
      const t = Math.min((now - startTime) / duration, 1);
      window.scrollTo(0, Math.round(start * (1 - easeOutCubic(t))));
      if (t < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  // Defer one frame so any layout change (e.g. new word list) settles first.
  requestAnimationFrame(animate);
}
